module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAKElEQVR4AWN4//FrA73xu03bJg1VPIpH8SgexfQuMw8fPdEz/PAoBgB8Q4YJcNLUJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/selfcare_main+rightcontainer.png
// module id = 351
// module chunks = 0